const buildCheckoutUrls = ({ host, encodedState }) => {
  const stateQuery = encodedState ? `state=${encodedState}` : ''
  const successQuery = [
    'session_id={CHECKOUT_SESSION_ID}',
    stateQuery
  ].filter(Boolean).join('&')

  return {
    successUrl: `${host}/after-payment?${successQuery}`,
    cancelUrl: `${host}/terms-and-conditions${stateQuery ? `?${stateQuery}` : ''}`
  }
}

module.exports = {
  buildCheckoutUrls
}
